import React, { useEffect, useRef, useState } from "react"
import ShowcaseCards from "./ShowcaseCards"
import Typography from "aldoo-ra/Typography"
import CMSRender from "aldoo-ra/CMS/cms-render"

const HomeCardsSection = () => {
  const containerRef = useRef(null)
  const leftSectionRef = useRef(null)
  const rightSectionRef = useRef(null)
  const [leftStyle, setLeftStyle] = useState({})
  const [position, setPosition] = useState("initial") // 'initial', 'fixed', or 'absolute'

  useEffect(() => {
    const handleScroll = () => {
      if (
        !containerRef.current ||
        !leftSectionRef.current ||
        !rightSectionRef.current
      )
        return

      const containerRect = containerRef.current.getBoundingClientRect()
      const leftRect = leftSectionRef.current.getBoundingClientRect()
      const rightRect = rightSectionRef.current.getBoundingClientRect()
      const windowHeight = window.innerHeight
      const leftHeight = leftRect.height

      // Calculate the point where left section should become fixed
      const centerPoint = windowHeight / 2 - leftHeight / 2

      if (containerRect.top > centerPoint) {
        // Initial scroll - both sections scroll normally
        setPosition("initial")
        setLeftStyle({
          position: "absolute",
          top: "0px",
        })
      } else if (rightRect.bottom > windowHeight / 2 + leftHeight / 2) {
        // Middle scroll - left section is fixed in center
        setPosition("fixed")

        setLeftStyle({
          position: "fixed",
          top: centerPoint + "px",
          width: leftRect.width + "px",
        })
      } else {
        // End scroll - left section becomes absolute
        // Calculate the bottom offset based on the container's remaining height
        const containerBottom = containerRect.bottom
        const rightBottom = rightRect.bottom
        const bottomOffset = containerBottom - rightBottom

        setPosition("absolute")
        setLeftStyle({
          position: "absolute",
          top: `${
            rightRect.height - leftHeight - bottomOffset + centerPoint
          }px`,
          width: leftRect.width + "px",
        })
      }
    }

    window.addEventListener("scroll", handleScroll)
    // Initial calculation
    handleScroll()

    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <div
      ref={containerRef}
      className="relative w-full min-h-screen bg-paper"
    >
      <div className="relative w-full max-w-w2_xl flex-col lg:flex-row items-center gap-[30px] px-[16px] md:px-px1_l xl:px-px1_xl md:py-[60px] lg:pt-[95px] lg:pb-[60px] xl:pb-[100px] mx-auto mb-[50px] md:mb-0">
        {/* Left Section */}
        <CMSRender
          contentType="PageSection"
          match={{ "content.name": "WhyOxfordDictionarySectionLeft" }}
          renderItem={(data) => {
            return (
              <div
                ref={leftSectionRef}
                style={leftStyle}
                className="relative hidden lg:block w-full lg:max-w-[320px] xl:max-w-[470px] h-[600px] pt-[160px]"
              >
                <img
                  src={data.images}
                  alt="Oxford Dictionary Logo"
                  className="relative w-[110px] h-[110px] mb-[54px] z-10"
                />

                <Typography component="h2" variant="h1" className="z-10">
                  {data.title}
                </Typography>

                {/* Blurred circle background on the left */}
                <div
                  className="absolute left-0 top-[150px] h-[120px] w-[120px] rounded-full bg-orange_primary/40 z-0"
                  style={{
                    filter: "blur(50px)",
                  }}
                />
              </div>
            )
          }}
        />

        {/* Right Section */}
        <div
          className="flex flex-col w-full lg:w-[67%] lg:max-w-[750px] xl:max-w-[858px] items-center lg:ml-auto"
          ref={rightSectionRef}
        >
          <ShowcaseCards />
        </div>
      </div>
    </div>
  )
}

export default HomeCardsSection
